import { observer } from "mobx-react-lite";
import Icon from "@mdi/react";
import { mdiCommentTextOutline } from "@mdi/js";
import { Button, TextArea } from "@heroui/react";
import { feedbackStore } from "@/stores/FeedbackStore";

const FeedbackCommentFooter: React.FC = observer(() => {
  const {
    commentText,
    commentSubmitAttempted,
    commentErrors,
    isCommentSubmitting,
    isDetailLoading,
    selectedFeedback,
  } = feedbackStore;

  const commentError =
    commentSubmitAttempted ? commentErrors.text : undefined;

  if (isDetailLoading || !selectedFeedback) return null;

  return (
    <div className="fb-comment-form" data-testid="feedback-comment-form">
      <div className="fb-comment-form__label">
        <Icon path={mdiCommentTextOutline} size={0.7} />
        <span>Новый комментарий</span>
      </div>
      <TextArea
        fullWidth
        rows={2}
        value={commentText}
        onChange={(e) => feedbackStore.setCommentText(e.target.value)}
        placeholder="Оставьте комментарий для коллег..."
        disabled={isCommentSubmitting}
        aria-invalid={!!commentError}
      />
      {commentError && (
        <span className="fbs-form-field__error">{commentError}</span>
      )}
      <div className="fb-comment-form__actions">
        <Button
          variant="primary"
          size="sm"
          onPress={() => void feedbackStore.submitComment()}
          isPending={isCommentSubmitting}
          isDisabled={!commentText.trim()}
          data-testid="feedback-comment-submit"
        >
          Отправить
        </Button>
      </div>
    </div>
  );
});

FeedbackCommentFooter.displayName = "FeedbackCommentFooter";
export default FeedbackCommentFooter;
